import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DateField from 'Components/UI/DateField';
import { fade } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    '& .MuiTextField-root': {
      fontWeight: theme.typography.fontWeightMedium,
    },
    '& .MuiInputBase-root': {
      color: theme.palette.facet.primaryBlue,
      background: theme.palette.facet.accentBlue20,
      fontWeight: theme.typography.fontWeightMedium,
      borderRadius: theme.radius.md,
      '& input': {
        alignSelf: 'flex-end',
        padding: theme.spacing(1, 0, 1.5, 0),
      },
    },
    '& .MuiInputBase-root.Mui-focused': {
      background: theme.palette.facet.accentBlue20,
    },
    '& .MuiFormLabel-root': {
      color: theme.palette.facet.primaryBlue,
      fontSize: theme.typography.h5.fontSize,
      fontWeight: theme.typography.fontWeightFacetBook,
      zIndex: 1,
      transform: 'translate(20px, 25px) scale(1)',
    },
    '& .MuiInputLabel-shrink': {
      color: theme.palette.common.black,
      transform: 'translate(12px, 15px) scale(0.75)',
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.facet.primaryBlue,
    },
    // --------- Start Disabling ----------------
    '& .MuiFormLabel-root.Mui-disabled:not(.Mui-error)': {
      color: theme.palette.action.disabled,
    },
    '& .MuiInputBase-root.Mui-disabled:not(.Mui-error)': {
      color: theme.palette.action.disabled,
      backgroundColor: theme.palette.action.disabledBackground,
      '&:hover': {
        backgroundColor: theme.palette.action.disabledBackground,
      },
      '& .MuiInputBase-input': {
        color: theme.palette.action.disabled,
      },
      '& .MuiSvgIcon-root': {
        color: theme.palette.action.disabled,
      },
    },
    // --------- End Disabling ----------------
    // --------- Start Error ----------------
    '& .MuiFormLabel-root.Mui-error': {
      color: fade(theme.palette.error.main, 0.8),
    },
    '& .MuiInputBase-root.Mui-error': {
      color: fade(theme.palette.error.main, 0.8),
      backgroundColor: fade(theme.palette.error.main, 0.3),
      '&:hover': {
        backgroundColor: fade(theme.palette.error.main, 0.3),
      },
      '& .MuiInputBase-input': {
        color: fade(theme.palette.error.main, 0.8),
      },
      '& .MuiSvgIcon-root': {
        color: fade(theme.palette.error.main, 0.8),
      },
    },
    // --------- End Error ----------------
    paddingBottom: theme.spacing(0),
  },
  textField: {
    width: '100%',
  },
  input: {
    minHeight: '67px', // <--- TODO: Make a const
    fontSize: theme.typography.h4.fontSize,
    paddingLeft: theme.spacing(2),
  },
});

const DateFieldStandardized = ({
  className,
  classes,
  placeholder,
  format,
  InputProps,
  ...rest
}) => {
  return (
    <DateField
      classes={{
        root: classNames(classes.root, classes.textField, className),
      }}
      InputProps={{
        ...InputProps,
        className: classes.input,
        disableUnderline: true,
      }}
      placeholder={placeholder}
      format={format}
      variant={'filled'}
      {...rest}
    />
  );
};

DateFieldStandardized.defaultProps = {
  className: '',
  format: 'MM/DD/YYYY',
  placeholder: 'MM/DD/YYYY',
  InputProps: {},
};

DateFieldStandardized.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  format: PropTypes.string,
  placeholder: PropTypes.string,
  InputProps: PropTypes.object,
};

export default withStyles(styles)(DateFieldStandardized);
